import * as types from "../Actions/Types";
import { ActiveApp } from "../Enums/Enums";

export interface ILoadScoutReducerState {
  scoutIsLoaded: boolean;
  scoutIsShowing: boolean;
  showSplashScreen: boolean;
  activeApp: ActiveApp;
}

const defaultState: ILoadScoutReducerState = {
    scoutIsLoaded: false,
    scoutIsShowing: false,
    showSplashScreen: true,
    activeApp: ActiveApp.SCOUT,
};

export const loadScout = (
    state: ILoadScoutReducerState = { ...defaultState },
    action
) => {
    switch (action.type) {
        case types.LOAD_SCOUT:
            return Object.assign({}, state, {
                scoutIsLoaded: action.data,
            });

        case types.SET_SCOUT_IS_SHOWING:
            return Object.assign({}, state, {
                scoutIsShowing: action.data,
            });

        case types.SET_ACTIVE_APP:
            return Object.assign({}, state, {
                activeApp: action.data,
            });

        case types.SET_SHOW_SPLASH_SCREEN:
            return Object.assign({}, state, {
                showSplashScreen: action.data,
            });

        default:
            return state;
    }
};
